const ItemWindowTypes=
{
    NewItem: 'NewItem',
    EditItem:'EditItem',
};

export default ItemWindowTypes;